<template>
  <div id="app">
      <!-- 路由匹配到的组件将显示在这里 -->
      <router-view> </router-view> 

      <!-- 底部tabbar 组件 -->
      <AppTabBar v-show="$route.meta.isShowTabbar"></AppTabBar>
  </div>
</template>

<script>
import AppTabBar from "@/components/AppTabBar";
import router from '@/router/index.js';

export default {
  name: 'App',
  components: {
    AppTabBar,
  },
  created(){
    document.title= JSON.parse(localStorage.getItem("rent")).rentName
            
  }
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
